import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../../../react-core/Flux/BaseStore";
import { AccountModelView } from "../../../../../../../../Wrap/Models/Domains/Transactions/Investments/AccountModelView";
import { AccountModelPortfolioDispatcher } from "./Variable";

export interface AccountModelPortfolioStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: AccountModelView;
}

export class AccountModelPortfolioStatic extends BaseStore<AccountModelPortfolioStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(AccountModelPortfolioDispatcher, (actionData) =>
            this.onAccountModelPortfolioStoreResponse(actionData)
        );
    }

    public getLastResult(): AccountModelPortfolioStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getAccountModelData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): AccountModelPortfolioStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onAccountModelPortfolioStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
